import { render, staticRenderFns } from "./product_description.vue?vue&type=template&id=c1f9306c&"
import script from "./product_description.vue?vue&type=script&lang=js&"
export * from "./product_description.vue?vue&type=script&lang=js&"
import style0 from "./product_description.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports